import { useEffect, useState } from 'react'
import { getUser, login } from './sso.js'

/**
 * Gates the app behind NexusLayer SSO.
 *
 * The redirect fires from an effect rather than during render — navigating
 * away mid-render leaves React mid-commit and logs a warning. A visitor with
 * no token sees the interstitial for the moment before the browser leaves.
 */
export default function RequireAuth({ children }) {
  const [user] = useState(getUser)

  useEffect(() => {
    if (!user) login()
  }, [user])

  if (!user) {
    return (
      <div className="grid place-items-center min-h-screen bg-ground">
        <div className="text-center">
          <div className="font-mono text-sm tracking-widest uppercase text-text mb-2">
            Vestige
          </div>
          <div className="text-xs text-text-dim">
            Redirecting to NexusLayer sign-in…
          </div>
          <button
            type="button"
            onClick={login}
            className="mt-4 px-3 py-1.5 rounded text-xs font-medium text-accent bg-accent-faint hover:bg-surface2 transition-colors"
          >
            Sign in now
          </button>
        </div>
      </div>
    )
  }

  return children(user)
}
